import { render, staticRenderFns } from "./ProjectMilestoneEdit.vue?vue&type=template&id=62d09137"
import script from "./ProjectMilestoneEdit.vue?vue&type=script&lang=js"
export * from "./ProjectMilestoneEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports